import request from "@/utils/request";

/**
 * POST a file related to custom field of type BOOKING
 */
export async function postBookingFile(
  fieldId: number,
  file: any,
  bookingToken: string,
  bookingId: number
): Promise<any> {
  const postData = new FormData();
  postData.append("fieldId", String(fieldId));
  postData.append("file", file);
  const response = await request({
    // url: `/group/${groupId}/additional-info/fields/file?bookingToken=${bookingToken}`,
    url: `/booking/${bookingId}/fields/file?bookingToken="${bookingToken}"`,
    method: "post",
    data: postData,
    headers: { "Content-Type": "multipart/form-data" },
  });

  return response.data;
}

/**
 * POST a file related to custom field of type TICKET
 */
export async function postTicketFile(
  fieldId: number,
  file: any,
  bookingToken: string,
  bookingId: number,
  pssId: number
): Promise<any> {
  const postData = new FormData();
  postData.append("fieldId", String(fieldId));
  postData.append("pss", String(pssId));
  postData.append("file", file);
  const response = await request({
    url: `/booking/${bookingId}/ticket/fields/file?bookingToken="${bookingToken}"`,
    method: "post",
    data: postData,
    headers: { "Content-Type": "multipart/form-data" },
  });

  return response.data;
}
